<div class="admission-wrapper">
    <app-admission-header [defaultLogo]="defaultLogo" [institute]="institute"/>
    <form [formGroup]="admissionForm">
        <app-program-course-section
                [courses]="courses"
                [group]="programCourseGroup"
                [programs]="programs"/>
        <app-student-information-section
                (numbersOnly)="allowNumbersOnly($event)"
                [bloodGroupsType]="bloodGroupsType"
                [castCategoryType]="castCategoryType"
                [genders]="genders"
                [group]="studentInfoGroup"
                [motherTongue]="motherTongue"
                [religions]="religions"/>
        <app-guardian-section
                (add)="addGuardian()"
                (numbersOnly)="allowNumbersOnly($event)"
                (remove)="removeGuardian($event)"
                [formArray]="guardians"
                [relations]="relations"/>
        <app-address-section
                (numbersOnly)="allowNumbersOnly($event)"
                [addressType]="addressType"
                [cities]="cities"
                [group]="addressGroup"
                [states]="states"/>
        <app-siblings-section
                (add)="addSibling()"
                (remove)="removeSibling($event)"
                [allCourses]="allCourses"
                [formArray]="siblings"
                [siblingRelationType]="siblingRelationType"/>
        <div class="section-card">
            <div class="section-header">
                <span class="s-icon">📝</span>
                <h3>Additional Notes</h3>
            </div>
            <div class="section-body">
                <textarea class="f-textarea" formControlName="additional_notes" placeholder="Any additional information..."></textarea>
            </div>
        </div>

        @if (admissionFeeAmount) {
            <div class="warning-note-card">
                <div class="note-title">⚠️ Important Payment Information</div>
                Your admission will be considered complete only after the full payment of the prescribed admission fee.
                Once the application is submitted, a payment link for the <strong>Admission Application Fee
                ({{ admissionFeeAmount }}/-)
            </strong> will be sent to the father's email address. Please ensure the correct email is provided.
                <br><br>
                The fee is <strong>non-refundable</strong> and subject to the institute's policies. Kindly make all payments through official channels and retain the payment receipt for future reference.
            </div>
        } @else {
            <div class="success-note-card">
                <div class="note-title">ℹ️ Important Information</div>
                There is no admission application fee payable for this application. Since the prescribed admission fee is <strong>
                ({{ admissionFeeAmount ?? '₹0' }})
            </strong> you do not need to make any payment to complete the application.
                <br><br>
                Your application will be processed by the institute as per the admission procedure. Please ensure that all the information provided in the application is correct and complete
                <br><br>
                If any additional fee becomes applicable at a later stage, the institute will provide the relevant payment details through the official communication channels.
            </div>
        }

        <button (click)="onSubmit()"
                [disabled]="!admissionForm.valid || loading"
                class="btn-submit"
                type="submit">
            @if (loading) {
                <span class="spinner"></span> Please wait...
            } @else {
                Submit Admission Form →
            }
        </button>
    </form>
</div>
